// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ChromeOutlinedSvg from "@fishx/icons-svg/es/asn/ChromeOutlined";
import FishxIcon from '../components/FishxIcon';

var ChromeOutlined = function ChromeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ChromeOutlinedSvg
  }));
};

ChromeOutlined.displayName = 'ChromeOutlined';
export default React.forwardRef(ChromeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ChromeOutlined.js
// module id = 2203
// module chunks = 0